import http from "@/http/aisea/axios";
const resource = "/enterprises/crews/licenses";

export default {
  fetchList(payload) {
    return http.get(`${resource}`, {
      params: payload,
    });
  },
};
